import { useCallback, useEffect } from "react";
import { ButtonGroup } from "common/components/buttonGroup/buttonGroup";
import { RecruiterActivity } from "redux/models/recruiterActivity";
import { useAPIRequest } from "hooks/useAPIRequest";
import { usePageFilter } from "hooks/usePageFilters";
import { Section } from "features/dashboard/components/section";
import { TasksContent } from "features/dashboard/sections/tasks/tasksContent/tasksContent";
import styles from "features/dashboard/sections/tasks/tasks.module.scss";
import K from "../../../../utilities/constants";

export const TABS = {
  today: { key: "today", label: "Today", dueLabel: "today" },
  past: { key: "past", label: "Past Due", dueLabel: "past due" },
};

export const Tasks = ({ clientId, recruiterId }) => {
  const [due, setDue] = usePageFilter("dashboard_tasks_due", TABS.today.key);
  const activeTab = TABS[due];

  const fetchTasksCallback = useCallback(async () => {
    const { data } = await RecruiterActivity.tasks(
      clientId,
      recruiterId,
      { due },
      false,
    );
    return { data: { data, due } };
  }, [clientId, recruiterId, due]);

  const {
    data,
    loading,
    error,
    execute: fetchTasks,
  } = useAPIRequest(fetchTasksCallback, {
    initialData: { data: {}, due: "today" },
    initialLoading: true,
  });

  const extra = (
    <ButtonGroup value={due} onChange={setDue} disabled={loading}>
      {Object.values(TABS).map((t) => (
        <ButtonGroup.Button key={t.key} value={t.key}>
          {t.label}
        </ButtonGroup.Button>
      ))}
    </ButtonGroup>
  );

  const getDueDateForGroup = (group) => {
    if (data.due === TABS.past.key) {
      return (task) => ({
        text: group.getDueDate(task),
        alertLevel: task.due.alertLevel ?? K.DaysInStatusAlertLevel.critical,
      });
    }

    if (!group.showDueDateForToday) return null;

    return (task) => ({ text: group.getDueDate(task) });
  };

  const getGroupDescription = (group) => {
    return group.getDescription(activeTab.dueLabel);
  };

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return (
    <Section
      title="My Tasks"
      extra={extra}
      contentMinHeight="360px"
      contentClassName={styles.tasksContainer}
    >
      <TasksContent
        data={data.data}
        loading={loading}
        error={error}
        onRetry={fetchTasks}
        getDueDateForGroup={getDueDateForGroup}
        getGroupDescription={getGroupDescription}
      />
    </Section>
  );
};
